import React from 'react';
import Box from "@mui/material/Box";
import { Button, InputBase, MenuItem, Select } from "@mui/material";
import { keyframes } from '@emotion/react';
import { FaRegSave } from "react-icons/fa";
import { VscDiscard } from "react-icons/vsc";

const pulseAnimation = keyframes`
    0% {background-color: #059a70;}
    50% {background-color: #036e4d;}
    100% {background-color: #059a70;}
`;

const TableToolbar = ({
  searchTerm,
  setSearchTerm,
  optionStatus,
  setOptionStatus,
  changes,
  onSave,
  onReset,
  optional,
  steps,
  columnsPreload,
  wasFileUploaded
}) => {
  const showSaveButton = changes || (optional && steps.length > 0 && !steps.find(step => step.stepName === columnsPreload[0])?.completed) || wasFileUploaded;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        pb: 1,
        position: 'sticky',
        top: 0,
        bgcolor: 'white',
        zIndex: 10,
        boxShadow: 1,
        width: '100%',
        flexShrink: 0,
        '@media (max-width: 550px)': {
          flexDirection: 'column',
          px: 2,
        },
        '@media (min-width: 768px) and (max-width: 1000px)': {
          flexDirection: 'column',
          px: 2,
        },
      }}
    >
      <InputBase
        placeholder="Buscar..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          border: '1px solid #ccc',
          px: 2,
          py: 1,
          flexGrow: 1,
          minWidth: 0,
          width: 'auto',
          '@media (max-width: 550px)': {
            width: '100%',
          },
          '@media (min-width: 768px) and (max-width: 1000px)': {
            width: '100%',
          },
        }}
      />
      
      <Select
        value={optionStatus}
        onChange={(e) => setOptionStatus(e.target.value)}
        sx={{
          minWidth: 150,
          borderRadius: 0,
          width: 'auto',
          '@media (max-width: 550px)': {
            width: '100%',
          },
          '@media (min-width: 768px) and (max-width: 1000px)': {
            width: '100%',
          },
        }}
        variant="outlined"
        displayEmpty
        renderValue={(selected) => selected ? optionStatus.charAt(0).toUpperCase() + optionStatus.slice(1) + 's' : 'Todos'}
      >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value="completo">Completos</MenuItem>
        <MenuItem value="incompleto">Incompletos</MenuItem>
        <MenuItem value="vazio">Vazios</MenuItem>
      </Select>

      {showSaveButton && (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'stretch',
            width: 'auto',
            '@media (max-width: 550px)': { width: '100%' },
            '@media (min-width: 768px) and (max-width: 1000px)': { width: '100%' },
          }}
        >
          <Button
            variant="contained"
            onClick={onSave}
            sx={{
              animation: `${pulseAnimation} 2s infinite`,
              color: 'white',
              textTransform: 'none',
              px: 2,
              py: 1,
              height: '100%',
              width: 'auto',
              '@media (max-width: 550px)': {
                width: '100%',
              },
              '@media (min-width: 768px) and (max-width: 1000px)': {
                width: '100%',
              },
              '&:hover': {
                backgroundColor: '#036e4d',
                animation: 'none',
              },
            }}
          >
            <FaRegSave className="mr-1 text-lg" />
            Salvar
          </Button>
        </Box>
      )}

      {(changes || wasFileUploaded) && (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'stretch',
            width: 'auto',
            '@media (max-width: 550px)': { width: '100%' },
            '@media (min-width: 768px) and (max-width: 1000px)': { width: '100%' },
          }}
        >
          <Button
            variant="contained"
            size="small"
            onClick={onReset}
            sx={{
              backgroundColor: '#ff6363',
              '&:hover': { backgroundColor: '#be3e3e' },
              color: 'white',
              textTransform: 'none',
              height: '100%',
              px: 2,
              py: 1,
              width: '100%',
              '@media (min-width: 1200px)': {
                width: 'auto',
              },
            }}
          >
            <VscDiscard className="mr-1 text-lg" />
            Descartar
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TableToolbar;
